(function (app, ng) {

    app.controller("addEventController", addEventController);

    addEventController.$inject = ["$mdDialog", "$q", "moment", "eventGroupApi", "ancillaryEventGroupApi", "_", "_formPattern"];
    function addEventController($mdDialog, $q, moment, eventGroupApi, ancillaryEventGroupApi, _, formPattern) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    saving: false
                },
                eventGroup: {
                    UserId: $ctrl.user.Id,
                    TypeId: $ctrl.eventType.Id
                },
                newEvent: {},
                dates: [new Date()],
                close: close,
                addEvent: addEvent,
                addMultiEvent: addMultiEvent,
                add: add,
                multiEvents: false,
                formPattern: formPattern
            });

        function close() {
            $mdDialog.cancel();
        }

        function add() {
            if ($ctrl.multiEvents === true) {
                addMultiEvent();
            }
            else {
                addEvent();
            }
        }

        //function addMultiEvent() {
        function addEvent() {
            $ctrl.ui.saving = true;
            var promises = [];
            var subpromises = [];

            var eventGroups = [];
            var api = !$ctrl.eventType.IsAncillary ? eventGroupApi : ancillaryEventGroupApi;

            ng.forEach(_.split($ctrl.dates, ","), function (date) {
                date = new Date(date);
                date.setHours(0, 0, 0, 0);
                promises.push(api.create($ctrl.eventGroup).then(function (evtGroup) {
                    evtGroup.Events = [];
                    evtGroup.EventType = $ctrl.eventType;

                    if (api === eventGroupApi) {
                        subpromises.push(api.addEvent(evtGroup.Id, {
                            Title: $ctrl.newEvent.Name,
                            EventDate: date
                        }).then(function (event) {
                            evtGroup.Events.push(event);
                            eventGroups.push(evtGroup);
                        }));
                    }
                    else {
                        subpromises.push(api.addAncillaryEvent(evtGroup.Id, {
                            Description: $ctrl.newEvent.Name,
                            EventDate: date
                        }).then(function (event) {
                            evtGroup.Events.push(event);
                            eventGroups.push(evtGroup);
                        }));
                    }
                }));
            });

            if ($ctrl.eventGroup.PlanningDate) {
                var date = new Date($ctrl.eventGroup.PlanningDate);
                date.setHours(0, 0, 0, 0);
                promises.push(api.create($ctrl.eventGroup).then(function (evtGroup) {
                    evtGroup.Events = [];
                    evtGroup.EventType = $ctrl.eventType;
                    if (api === eventGroupApi) {
                        subpromises.push(api.addEvent(evtGroup.Id,
                            {
                                Title: "Planning - " + $ctrl.newEvent.Name,
                                EventDate: date,
                                IsPlanning: true
                            }).then(function (event) {
                                evtGroup.Events.push(event);
                                eventGroups.push(evtGroup);
                            }));
                    }
                    else {
                        subpromises.push(api.addAncillaryEvent(evtGroup.Id,
                            {
                                Description: "Planning - " + $ctrl.newEvent.Name,
                                EventDate: date,
                                IsPlanning: true
                            }).then(function (event) {
                                evtGroup.Events.push(event);
                                eventGroups.push(evtGroup);
                            }));
                    }
                }));
            }

            $q.all(promises).then(function () {
                $q.all(subpromises).then(function () {
                    $ctrl.saving = false;
                    $mdDialog.hide(eventGroups);
                });
            });
        }
        function addMultiEvent() {
            var dates = $ctrl.dates;

            $ctrl.ui.saving = true;
            var api = !$ctrl.eventType.IsAncillary ? eventGroupApi : ancillaryEventGroupApi;

            api.create($ctrl.eventGroup).then(function (response) {
                var promises = [];
                $ctrl.eventGroup.Id = response.Id;
                $ctrl.eventGroup.EventType = $ctrl.eventType;
                $ctrl.eventGroup.Events = [];

                ng.forEach(_.split(dates, ","),
                    function (date) {
                        date = new Date(date);
                        date.setHours(0, 0, 0, 0);
                        if (api === eventGroupApi)
                            promises.push(api.addEvent(response.Id,
                                {
                                    Title: $ctrl.newEvent.Name,
                                    EventDate: date
                                }).then(function (response) {
                                    $ctrl.eventGroup.Events.push(response);
                                }));
                        else
                            promises.push(api.addAncillaryEvent(response.Id,
                                {
                                    Description: $ctrl.newEvent.Name,
                                    EventDate: date
                                }).then(function (response) {
                                    $ctrl.eventGroup.Events.push(response);
                                }));
                    });

                if ($ctrl.eventGroup.PlanningDate) {
                    var date = new Date($ctrl.eventGroup.PlanningDate);
                    date.setHours(0, 0, 0, 0);
                    if (api === eventGroupApi)
                        promises.push(api.addEvent(response.Id,
                            {
                                Title: "Planning - " + $ctrl.newEvent.Name,
                                EventDate: date,
                                IsPlanning: true
                            }).then(function (response) {
                                $ctrl.eventGroup.Events.push(response);
                            }));
                    else
                        promises.push(api.addAncillaryEvent(response.Id,
                            {
                                Description: "Planning - " + $ctrl.newEvent.Name,
                                EventDate: date,
                                IsPlanning: true
                            }).then(function (response) {
                                $ctrl.eventGroup.Events.push(response);
                            }));
                }

                $q.all(promises).then(function () {
                    $ctrl.saving = false;
                    $mdDialog.hide($ctrl.eventGroup);
                });
            });
        }

        $ctrl.$onInit = () => {
            $ctrl.ui.minDate = moment().year($ctrl.selectedYear).startOf("year").toDate();
            $ctrl.ui.maxDate = moment().year($ctrl.selectedYear).endOf("year").toDate();

            var today = new Date();
            if (today.getFullYear() !== $ctrl.selectedYear)
                $ctrl.ui.startDate = $ctrl.ui.minDate;
            else
                $ctrl.ui.startDate = today;
        };
    }

})(window.app, window.angular); //jshint ignore:line